import React from "react";
import appVar from "../dataVar/appVar";
import logger from "./logger";

// Captura excepciones de render de todo el árbol de componentes.
// Sin esto, un error en render deja la pantalla en blanco y no queda rastro.
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        logger.error(
            "Render error: " + (error?.message || String(error)),
            error,
            info?.componentStack || ""
        );
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (!this.state.hasError) return this.props.children;

        const isDev = process.env.NODE_ENV !== "production";

        return (
            <div
                style={{
                    minHeight: "100dvh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 16,
                    padding: 24,
                    textAlign: "center",
                    fontFamily: "system-ui, -apple-system, sans-serif",
                }}
            >
                <h2 style={{ margin: 0 }}>Ocurrió un error inesperado</h2>
                <p style={{ maxWidth: 480, color: "#666", margin: 0 }}>
                    La página no se pudo mostrar correctamente. El error quedó registrado.
                    Intente recargar; si el problema persiste, contacte a soporte.
                </p>

                {isDev && this.state.error && (
                    <pre
                        style={{
                            maxWidth: "90vw",
                            overflow: "auto",
                            textAlign: "left",
                            background: "#f5f5f5",
                            padding: 12,
                            borderRadius: 6,
                            fontSize: 12,
                        }}
                    >
                        {String(this.state.error?.stack || this.state.error)}
                    </pre>
                )}

                <button
                    type="button"
                    onClick={this.handleReload}
                    style={{
                        padding: "8px 20px",
                        border: "none",
                        borderRadius: 6,
                        background: appVar.gColorCorp,
                        color: "#fff",
                        cursor: "pointer",
                        fontSize: 14,
                    }}
                >
                    Recargar
                </button>
            </div>
        );
    }
}

export default ErrorBoundary;
